import React from 'react';
import CustomYear from './CustomYear';
import { PeriodsProps } from './utils';
import ShowPeriod from './ShowPeriod';

const Periods: React.FC<PeriodsProps> = props => {
  switch (props.periodType) {
    // case 'calendarYear':
    //   return <CalendarYear {...props} />;
    // case 'academicYear':
    //   return <AcademicYear {...props} />;
    // case 'fiscalYear':
    //   return <FiscalYear {...props} />;
    case 'customYear':
      return <CustomYear {...props} />;

    default:
      return <ShowPeriod {...props} />;
  }
};

export default Periods;
